import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// SECURITY: Environment variables are REQUIRED
// In development: Create a .env file with VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
// In production: Set these in your hosting platform (Cloudflare Pages, Vercel, etc.)
const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL as string).replace(/\/$/, '');
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate required environment variables
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    'Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file or hosting platform.'
  );
}

// Export URL for use in other parts of the app (e.g., storage URLs)
export { SUPABASE_URL };

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});